import contactInfo_en from './contact-info_en.json'
import forms_en from './forms_en.json'

const fde_us_resources = {
  en: {
    ...forms_en,
    ...contactInfo_en,
  },
}

export default fde_us_resources
